// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"e6b091de","607":"87ed5607"}[chunkId] + ".chunk.css";
};